export default __webpack_public_path__ + "static/media/sensotrend_uploader_search_win.ba8faff8.png";